import http from './http'

export type NotificationType = 'due_soon' | 'overdue'

export interface NotificationInvoice {
  id: number
  invoice_number: string
  provider_name: string
  due_date: string
  balance: number
}

export interface AppNotification {
  id: number
  type: NotificationType
  message: string
  invoice: NotificationInvoice | null
  is_read: boolean
  read_at: string | null
  created_at: string
}

export interface NotificationsMeta {
  current_page: number
  last_page: number
  per_page: number
  total: number
  from: number | null
  to: number | null
}

export interface NotificationsListResponse {
  data: AppNotification[]
  meta: NotificationsMeta
}

// NOTE: single-resource endpoints (`.../read`) are assumed to wrap the notification in a
// `{ data }` envelope, same convention assumed for the rest of the API — see
// src/services/providers.ts.
interface NotificationEnvelope {
  data: AppNotification
}

const list = (page = 1) =>
  http.get<NotificationsListResponse>('/notifications', { params: { page } }).then((response) => response.data)

const getUnreadCount = () =>
  http.get<{ count: number }>('/notifications/unread-count').then((response) => response.data.count)

const markAsRead = (id: AppNotification['id']) =>
  http.post<NotificationEnvelope>(`/notifications/${id}/read`).then((response) => response.data.data)

const markAllAsRead = () => http.post('/notifications/mark-all-read')

export default { list, getUnreadCount, markAsRead, markAllAsRead }
